import { isNullish, formatUserInitials } from '@caresend/utils';
import { defineComponent, computed, ref } from 'vue';
import __vue_component__ from '../ImageComponent.vue.js';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import { getSeededColor, mutateColorBrightness } from '../../../functions/color.js';
import '../Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';

var script = defineComponent({
    name: 'UserPhoto',
    components: {
        ImageComponent: __vue_component__,
    },
    props: {
        componentStyle: {
            type: String,
            default: 'outline-grey',
        },
        user: {
            type: [Object, String],
            default: null,
        },
        userInfo: {
            type: Object,
            default: null,
        },
        size: {
            type: Number,
            default: 96,
        },
        useSeededColor: {
            type: Boolean,
            default: false,
        },
        extraSeed: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const info = computed(() => {
            var _a, _b, _c;
            if (typeof props.user !== 'string'
                && !isNullish((_a = props.user) === null || _a === void 0 ? void 0 : _a.info)) {
                return (_c = (_b = props.user) === null || _b === void 0 ? void 0 : _b.info) !== null && _c !== void 0 ? _c : null;
            }
            return props.userInfo;
        });
        const userPicture = computed(() => { var _a; return (_a = info.value) === null || _a === void 0 ? void 0 : _a.picture; });
        const classNames = computed(() => {
            const names = [];
            switch (props.componentStyle) {
                case 'outline-grey':
                    names.push('UserPhoto--outline-grey');
                    break;
                case 'dark-grey':
                    names.push('UserPhoto--dark-grey');
            }
            if (userPicture.value)
                names.push('UserPhoto--with-image');
            return names;
        });
        const initials = computed(() => {
            var _a;
            if ((isNullish(props.user)
                && isNullish(props.userInfo))
                || (typeof props.user === 'string')) {
                return null;
            }
            const user = (_a = props.user) !== null && _a !== void 0 ? _a : {
                info: props.userInfo,
            };
            return formatUserInitials(user);
        });
        const sizeStyle = computed(() => ({
            height: `${props.size}px`,
            width: `${props.size}px`,
            minWidth: `${props.size}px`,
            maxWidth: `${props.size}px`,
            fontSize: `${props.size < 32 ? props.size * 0.4735 : props.size * 0.325}px`,
        }));
        const photoFailedToLoad = ref(false);
        const colorStyle = computed(() => {
            if (props.useSeededColor && props.user) {
                const id = typeof props.user !== 'string' ? props.user.id : props.user;
                const color = getSeededColor(id !== null && id !== void 0 ? id : JSON.stringify(info.value));
                return {
                    backgroundColor: `${mutateColorBrightness(color, -30)} !important`,
                    opacity: '0.7',
                    color: 'white !important',
                };
            }
            return {};
        });
        return {
            classNames,
            colorStyle,
            info,
            initials,
            photoFailedToLoad,
            sizeStyle,
            userPicture,
        };
    },
});

export { script as default };
